import { Container, Graphics, Text } from 'pixi.js';
import { theme } from '../config/theme';

export class CredentialPopup extends Container {
  private bg: Graphics;
  private text: Text;
  private lifetime = 0;
  private maxLifetime = 120; // frames at 60fps = 2s

  constructor(claims: string[], x: number, y: number) {
    super();
    this.x = x;
    this.y = y;

    this.bg = new Graphics();
    this.addChild(this.bg);

    const lines = claims.map(c => `• ${c}`).join('\n');
    this.text = new Text({
      text: lines,
      style: {
        fontFamily: theme.fonts.mono,
        fontSize: 9,
        fill: theme.colors.flashGranted,
        lineHeight: 12,
      },
    });
    this.text.x = 6;
    this.text.y = 4;
    this.addChild(this.text);

    // Draw rounded rect background
    const w = this.text.width + 12;
    const h = this.text.height + 8;
    this.bg.fill({ color: 0x0A0A0F, alpha: 0.6 });
    this.bg.roundRect(-w/2, -h/2, w, h, 4);
    this.bg.fill();
    this.bg.stroke({ color: theme.colors.flashGranted, width: 1, alpha: 0.3 });
    this.bg.roundRect(-w/2, -h/2, w, h, 4);
    this.bg.stroke();

    // Center text
    this.text.x = -this.text.width / 2;
    this.text.y = -this.text.height / 2;

    this.alpha = 0;
  }

  tick(): boolean {
    this.lifetime++;
    const progress = this.lifetime / this.maxLifetime;

    if (progress < 0.1) {
      this.alpha = progress / 0.1; // fade in
    } else if (progress > 0.7) {
      this.alpha = 1 - (progress - 0.7) / 0.3; // fade out
    } else {
      this.alpha = 1;
    }

    // Float upward slightly
    this.y -= 0.3;

    return this.lifetime < this.maxLifetime;
  }
}
